import i18n from 'services/base/i18n';

export default {
  // Title for the bandwidth settings page
  bandWidthSettings: () => i18n.pgettext('Pages|Bandwidth Settings', 'BANDWIDTH SETTINGS'),
  // Button to save changes
  save: () => i18n.pgettext('Pages|Bandwidth Settings', 'SAVE'),
  // Label for the maximum download speed of the network
  download: () => i18n.pgettext('Pages|Bandwidth Settings', 'DOWNLOAD'),
  // Label for the maximum upload speed of the network
  upload: () => i18n.pgettext('Pages|Bandwidth Settings', 'UPLOAD'),
  downloadUnit: (downloadUnit: string) => downloadUnit,
  uploadUnit: (uploadUnit: string) => uploadUnit,
  // Label for a switch to toggle whether the Pangolin's "Anti-Bufferbloat" feature should be turned on
  enableAntiBufferBloat: () => i18n.pgettext('Pages|Bandwidth Settings', 'Enable anti-bufferbloat'),
  // Short explanation for what the "Anti-Bufferbloat" feature is
  antiBufferBloatInstructions: () => i18n.pgettext('Pages|Bandwidth Settings', 'Automatically reduce network latency'),
  // Label for a switch to toggle whether the Pangolin's Bandwidth Prioritization feature is enabled
  enableBandwidthControls: () => i18n.pgettext('Pages|Bandwidth Settings', 'Enable bandwidth controls'),
  // Warning for the user about potential downsides of enabling Bandwidth Prioritization
  bandwidthControlsInstructions: () => i18n.pgettext('Pages|Bandwidth Settings', 'This will potentially slow down your internet'),
  // Title for some explanation text on bufferbloat
  whatIsBufferbloat: () => i18n.pgettext('Pages|Bandwidth Settings', 'What is bufferbloat?'),
  // The content of that explanation on bufferbloat
  antiBufferBloatInformation: () => i18n.pgettext('Pages|Bandwidth Settings', 'Our anti-buffer bloat features helps prevent lag spikes.'),
  // Title on some explanation text on our Bandwidth Prioritization feature
  whatIsBandwidthControls: () => i18n.pgettext('Pages|Bandwidth Settings', 'What is bandwidth controls?'),
  bandwidthControlsInformation: () => (
    // The content of that explanation on Bandwidth Prioritization
    i18n.pgettext('Pages|Bandwidth Settings', 'Bandwidth controls will allow you to partition a percentage of bandwidth to specific devices, but may slow down your overall download speeds.')
  ),
};
